import { DependencyInjectId } from "@@/package/const/DependencyInjectId";
import HttpClient from "@@/package/network/HttpClient";
import { type AxiosResponse } from "axios";
import { type ApplicationContextInterface } from "@@/package/application/applicationContext";
import { ProfileModel } from "~~/package/mapper/profile/model/ProfileModel";
import { ProfileUserInformationModel } from "~~/package/mapper/profile/model/ProfileUserInformationModel";
import {
    ProfileUserInformationWorkExperienceModel, ProfileWorkExperienceCreateModel
} from "~~/package/mapper/profile/model/ProfileUserInformationWorkExperienceModel";
import {
    ProfileEducationCreateModel,
    ProfileUserInformationEducationModel
} from "~~/package/mapper/profile/model/ProfileUserInformationEducationModel";
import type CustomResponse from "~~/package/types/ResponseType";

export default class ProfileApi {

    protected http: HttpClient;

    constructor(context: ApplicationContextInterface) {
        this.http = context.getService<HttpClient>(DependencyInjectId.HttpClient);
    }

    public getUserMyProfile(lang: string): Promise<AxiosResponse<CustomResponse<ProfileModel>>> {
        return this.http.get<AxiosResponse<CustomResponse<ProfileModel>>>('/v2/user/my/profile', undefined, true, lang);
    }

    public getUserShareProfile(uuid: string, lang: string): Promise<AxiosResponse<CustomResponse<ProfileModel>>> {
        return this.http.get<AxiosResponse<CustomResponse<ProfileModel>>>(`/v2/user/${uuid}/profile`, undefined, false, lang);
    }

    public getUserWorkExperienceList(isShare: boolean, lang: string, uuid: string): Promise<AxiosResponse<CustomResponse<ProfileUserInformationWorkExperienceModel[]>>> {
        return isShare ?
          this.http.get<AxiosResponse<CustomResponse<ProfileUserInformationWorkExperienceModel[]>>>(`/v2/user/${uuid}/profile/workExperience`, undefined, true, lang) :
          this.http.get<AxiosResponse<CustomResponse<ProfileUserInformationWorkExperienceModel[]>>>('/v2/user/my/profile/workExperience', undefined, true, lang);
    }

    public getUserEducationList(isShare: boolean, lang: string, uuid: string): Promise<AxiosResponse<CustomResponse<ProfileUserInformationEducationModel[]>>> {
        return isShare ?
          this.http.get<AxiosResponse<CustomResponse<ProfileUserInformationEducationModel[]>>>(`/v2/user/${uuid}/profile/education`, undefined, true, lang) :
          this.http.get<AxiosResponse<CustomResponse<ProfileUserInformationEducationModel[]>>>('/v2/user/my/profile/education', undefined, true, lang);
    }

    public getUserSkills(): Promise<AxiosResponse<CustomResponse<string[]>>> {
        return this.http.get<AxiosResponse<CustomResponse<string[]>>>(`/v2/user/profile/skills`, undefined, true);
    }

    public modifyUserProfile(profileData: ProfileUserInformationModel): Promise<AxiosResponse<CustomResponse<ProfileUserInformationModel>>> {
        return this.http.patch<AxiosResponse<CustomResponse<ProfileUserInformationModel>>, ProfileUserInformationModel>('/v2/user/my/profile', profileData, true);
    }

    public addAboutMe(title: string, content: string): Promise<AxiosResponse<CustomResponse<boolean>>> {
        return this.http.post<AxiosResponse<CustomResponse<boolean>>, {}>('/v2/user/my/profile/aboutMe', { title, content }, true);
    }

    public addWorkExperience(workExperience: ProfileWorkExperienceCreateModel): Promise<AxiosResponse<CustomResponse<boolean>>> {
        return this.http.post<AxiosResponse<CustomResponse<boolean>>, {}>('/v2/user/my/profile/workExperience', workExperience, true);
    }

    public addEducation(education: ProfileEducationCreateModel): Promise<AxiosResponse<CustomResponse<boolean>>> {
        return this.http.post<AxiosResponse<CustomResponse<boolean>>, {}>('/v2/user/my/profile/education', education, true);
    }

    public modifyAboutMe(id: number, title: string, content: string): Promise<AxiosResponse<CustomResponse<boolean>>> {
        return this.http.put<AxiosResponse<CustomResponse<boolean>>, {}>('/v2/user/my/profile/aboutMe', { id, title, content }, true);
    }

    public modifyWorkExperience(workExperience: ProfileWorkExperienceCreateModel): Promise<AxiosResponse<CustomResponse<boolean>>> {
        return this.http.put<AxiosResponse<CustomResponse<boolean>>, {}>('/v2/user/my/profile/workExperience', workExperience, true);
    }

    public modifyEducation(education: ProfileEducationCreateModel): Promise<AxiosResponse<CustomResponse<boolean>>> {
        return this.http.put<AxiosResponse<CustomResponse<boolean>>, {}>('/v2/user/my/profile/education', education, true);
    }

    public deleteAboutMe(id: number): Promise<AxiosResponse<CustomResponse<boolean>>> {
        return this.http.delete<AxiosResponse<CustomResponse<boolean>>>(`/v2/user/my/profile/aboutMe/${id}`,undefined, true);
    }

    public deleteWorkExperience(id: number): Promise<AxiosResponse<CustomResponse<boolean>>> {
        return this.http.delete<AxiosResponse<CustomResponse<boolean>>>(`/v2/user/my/profile/workExperience/${id}`,undefined, true);
    }

    public deleteEducation(id: number): Promise<AxiosResponse<CustomResponse<boolean>>> {
        return this.http.delete<AxiosResponse<CustomResponse<boolean>>>(`/v2/user/my/profile/education/${id}`,undefined, true);
    }

    public profileImageUpdate(formData: FormData): Promise<AxiosResponse<CustomResponse<boolean>>> {
        return this.http.put<AxiosResponse<CustomResponse<boolean>>, FormData>('/user/profile/image', formData, true, true);
    }
}
